export enum $browserTimeouts {
  swaTimeouts = 'swaTimeouts',
  aufTimeouts = 'aufTimeouts',
}

export enum $browserSwaTimeouts {
  SWA_SUCCESS_FIELD = 'swaSuccessTimeout',
  SWA_SUBMIT_FIELD = 'swaSubmitTimeout',
  SWA_USER_NAME_FIELD = 'swaUsernameTimeout',
  SWA_PASSWORD_FIELD = 'swaPasswordTimeout',
  POPUP_DISMISS = 'popupDismissTimeout',
  PAGE_STABILIZATION = 'pageStabilizationTimeout',
  PAGE_REDIRECTS_STABILIZATION = 'pageRedirectsStabilizationTimeout',
}

export enum $browserAufTimeouts {
  USER_FLOW_CLICK_TIMEOUT = 'clickTimeout',
  USER_FLOW_OPEN_URL_TIMEOUT = 'openUrlTimeout',
  USER_FLOW_WAIT_ELEMENT_TIMEOUT = 'waitForElementTimeout',
  USER_FLOW_NAVIGATION_TIMEOUT = 'navigationTimeout',
  USER_FLOW_KEYSTROKE_INTERVAL = 'keystrokeInterval',
  USER_FLOW_CLICK_DELAY = 'clickDelay',
}

export const BROWSER_SWA_TIMEOUTS: Readonly<Record<string, number>> = {
  [$browserSwaTimeouts.SWA_SUCCESS_FIELD]: 20000,
  [$browserSwaTimeouts.SWA_SUBMIT_FIELD]: 10000,
  [$browserSwaTimeouts.SWA_USER_NAME_FIELD]: 10000,
  [$browserSwaTimeouts.SWA_PASSWORD_FIELD]: 10000,
  [$browserSwaTimeouts.POPUP_DISMISS]: 10000,
  [$browserSwaTimeouts.PAGE_STABILIZATION]: 20000,
  [$browserSwaTimeouts.PAGE_REDIRECTS_STABILIZATION]: 10000,
};

export const BROWSER_AUF_TIMEOUTS: Readonly<Record<string, number>> = {
  [$browserAufTimeouts.USER_FLOW_CLICK_TIMEOUT]: 30 * 1000,
  [$browserAufTimeouts.USER_FLOW_OPEN_URL_TIMEOUT]: 30 * 1000,
  [$browserAufTimeouts.USER_FLOW_WAIT_ELEMENT_TIMEOUT]: 60 * 1000,
  [$browserAufTimeouts.USER_FLOW_NAVIGATION_TIMEOUT]: 15 * 1000,
  [$browserAufTimeouts.USER_FLOW_KEYSTROKE_INTERVAL]: 50,
  [$browserAufTimeouts.USER_FLOW_CLICK_DELAY]: 50,
};
